import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle/slide-toggle';

type InputType = 'checkbox' | 'toggle';
type LabelPosition = 'before' | 'after';

@Component({
  selector: 'app-universal-toggle',
  templateUrl: './universal-toggle.component.html',
  styleUrls: ['./universal-toggle.component.scss'],
})
export class UniversalToggleComponent implements OnInit {
  @Input() fControl: FormControl | AbstractControl;
  @Input() inputType: InputType = 'toggle';

  // style
  @Input() label: string;
  @Input() labelPosition: LabelPosition = 'after';
  @Input() wrapperCssClass: string;

  constructor() {}

  ngOnInit() {}
}
